"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _header = _interopRequireDefault(require("@insided/deprecated-control/header"));

var _Loader = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Loader"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _PublicTagSettings = _interopRequireDefault(require("@insided/deprecated-control/public-tag-overview/PublicTagSettings"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PaginationComponent = _interopRequireDefault(require("@insided/deprecated-control/ui-components/PaginationComponent"));

var _Table = _interopRequireDefault(require("@insided/deprecated-preact-components/table/Table"));

var _EmptyPage = _interopRequireDefault(require("@insided/deprecated-preact-components/empty-page/EmptyPage"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _AddPublicTag = _interopRequireDefault(require("@insided/deprecated-control/public-tag-overview/AddPublicTag"));

var _PublicTagModals = require("@insided/deprecated-control/public-tag-overview/PublicTagModals");

var _SearchPublicTags = _interopRequireDefault(require("@insided/deprecated-control/public-tag-overview/SearchPublicTags"));

var _MergePublicTags = _interopRequireDefault(require("@insided/deprecated-control/public-tag-overview/MergePublicTags"));

var _utils = require("@insided/deprecated-control/public-tag-overview/utils");

var PublicTagOverviewPresenter = function PublicTagOverviewPresenter(_ref) {
  var _pagination$pageSizes;

  var tagsToMerge = _ref.tagsToMerge,
      tags = _ref.tags,
      tagIndex = _ref.tagIndex,
      pagination = _ref.pagination,
      setAlertMessage = _ref.setAlertMessage,
      setIsLoading = _ref.setIsLoading,
      setTagsAndPagination = _ref.setTagsAndPagination,
      onSearchInput = _ref.onSearchInput,
      isLoading = _ref.isLoading,
      messageType = _ref.messageType,
      message = _ref.message,
      showTagCreationSetting = _ref.showTagCreationSetting,
      selectAllTags = _ref.selectAllTags,
      selectAllTagsOnPage = _ref.selectAllTagsOnPage,
      selectTag = _ref.selectTag,
      onEditTag = _ref.onEditTag,
      onRemoveTag = _ref.onRemoveTag,
      onPageChange = _ref.onPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      tagToEdit = _ref.tagToEdit,
      tagToDelete = _ref.tagToDelete,
      onClickEditModalInput = _ref.onClickEditModalInput,
      modalErrorMessage = _ref.modalErrorMessage,
      editTag = _ref.editTag,
      deleteTag = _ref.deleteTag,
      closeEditModal = _ref.closeEditModal,
      closeDeleteModal = _ref.closeDeleteModal;
  var isVisibleFor = messageType === 'success' ? 5000 : false;
  var totalCountText = pagination.total === 1 ? 'Public tag' : 'Public tags';
  var showMergeButtonInHeader = tagsToMerge.length > 1 || selectAllTagsOnPage;
  pagination.pageSizes = (_pagination$pageSizes = pagination.pageSizes) !== null && _pagination$pageSizes !== void 0 ? _pagination$pageSizes : [10, 25, 50];
  var paginationOptions = {
    pagination: pagination,
    onPageChange: onPageChange,
    onPageSizeChange: onPageSizeChange
  };
  var tableRows = (0, _utils.getTableRows)(tags, selectAllTags, selectAllTagsOnPage, selectTag, onEditTag, onRemoveTag);
  var mergeButton = (0, _preact.h)(_MergePublicTags.default, {
    tagsToMerge: tagsToMerge,
    tags: tags,
    tagIndex: tagIndex,
    pagination: pagination,
    setAlertMessage: setAlertMessage,
    setIsLoading: setIsLoading,
    setTagsAndPagination: setTagsAndPagination
  });
  var customButtons = [(0, _preact.h)(_SearchPublicTags.default, {
    key: 0,
    onInput: onSearchInput
  }), (0, _preact.h)(_AddPublicTag.default, {
    key: 1,
    pagination: pagination,
    setAlertMessage: setAlertMessage,
    setIsLoading: setIsLoading,
    setTagsAndPagination: setTagsAndPagination,
    tags: tags
  })];

  if (showMergeButtonInHeader) {
    customButtons.unshift(mergeButton);
  }

  return (0, _preact.h)("div", {
    className: "public-tag-overview qa-public-tag-overview"
  }, (0, _preact.h)(_header.default, {
    title: "Public Tags",
    disableCancelButton: true,
    disableSaveButton: true,
    customButtons: customButtons
  }), (0, _preact.h)("div", null, isLoading && (0, _preact.h)(_Loader.default, null), messageType ? (0, _preact.h)(_AlertComponent.default, {
    messageType: messageType,
    message: message,
    sticky: true,
    isVisibleFor: isVisibleFor
  }) : null, showTagCreationSetting && (0, _preact.h)(_PublicTagSettings.default, {
    setAlertMessage: setAlertMessage
  }), tags.length > 0 ? (0, _preact.h)("div", {
    className: (0, _classnames.default)('control-body', 'public-tags-overview-table', 'qa-public-tags-overview-table')
  }, (0, _preact.h)("div", {
    className: "public-tags__table-info"
  }, (0, _preact.h)("span", {
    className: "public-tags__counter"
  }, paginationOptions.pagination.total, " ", totalCountText), (0, _preact.h)(_PaginationComponent.default, paginationOptions)), (0, _preact.h)(_Table.default, {
    rows: tableRows,
    rowId: "id",
    classes: ['public_tag__table']
  })) : (0, _preact.h)(_EmptyPage.default, {
    img_src: "".concat((0, _globals.default)('defaultCdn'), "/images/tags_empty_page.png"),
    header: "No public tags found",
    text: "Help users find more relevant content by adding public tags." // eslint-disable-next-line react/no-children-prop
    ,
    children: (0, _preact.h)(_AddPublicTag.default, {
      pagination: pagination,
      setAlertMessage: setAlertMessage,
      setIsLoading: setIsLoading,
      setTagsAndPagination: setTagsAndPagination,
      tags: tags
    })
  }), tagToEdit && (0, _preact.h)(_PublicTagModals.EditModal, {
    tag: tagToEdit.name,
    onClose: closeEditModal,
    onClick: onClickEditModalInput,
    onSave: /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(newName) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return editTag(tagToEdit, newName);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
    error: modalErrorMessage
  }), tagToDelete && (0, _preact.h)(_PublicTagModals.DeleteModal, {
    tag: tagToDelete.name,
    onClose: closeDeleteModal,
    onDelete: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return deleteTag(tagToDelete);

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))
  })));
};

var _default = PublicTagOverviewPresenter;
exports.default = _default;